export const CONMEBOL = { id: 1, nombre: 'Sudamerica', oficialidad: 4 };
export const UEFA = { id: 2, nombre: 'Europa', oficialidad: 10 };
export const CONCACAF = { id: 3, nombre: 'Concacaf', oficialidad: 13 };
export const CAF = { id: 4, nombre: 'Africa', oficialidad: 12 };
export const AFC = { id: 5, nombre: 'Asia', oficialidad: 11 };
export const OFC = { id: 6, nombre: 'Oceanía', oficialidad: 19 };
